import { useState, useEffect, createContext, useContext } from 'react';
import axios from 'axios';

const AuthContext = createContext();
console.log(import.meta.env);
const backendUrl =
    import.meta.env.MODE === 'development'
        ? `http://${import.meta.env.VITE_BACKEND_URL}`
        : `https://${import.meta.env.VITE_BACKEND_URL_PROD}`;
export const AuthProvider = ({ children }) => {
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [loading, setLoading] = useState(true);
    const [user, setUser] = useState(null);

    useEffect(() => {
        // Check if token exists in localStorage
        const token = localStorage.getItem('token');
        if (token) {
            setIsAuthenticated(true);
            // You could also validate the token with the server here
        }
        setLoading(false);
    }, []);

    const login = async (username, password) => {
        try {
            // Create form data
            const formData = new URLSearchParams();
            formData.append('username', username);
            formData.append('password', password);

            const response = await axios.post(
                `${backendUrl}/admin/login`,
                formData,
                {
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded',
                    },
                }
            );

            const { access_token } = response.data;
            localStorage.setItem('token', access_token);

            // Set auth headers for future requests
            axios.defaults.headers.common[
                'Authorization'
            ] = `Bearer ${access_token}`;

            setIsAuthenticated(true);
            return { success: true };
        } catch (error) {
            console.error('Login error:', error);
            return {
                success: false,
                message:
                    error.response?.data?.detail ||
                    'Login failed. Please try again.',
            };
        }
    };

    const logout = () => {
        localStorage.removeItem('token');
        delete axios.defaults.headers.common['Authorization'];
        setIsAuthenticated(false);
        setUser(null);
    };

    return (
        <AuthContext.Provider
            value={{ isAuthenticated, loading, user, login, logout }}
        >
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => {
    return useContext(AuthContext);
};
